module.exports = __webpack_public_path__ + "img/dashboard.9b5016b1.jpg";